"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _TopicPreviewNotice = _interopRequireDefault(require("./TopicPreviewNotice"));

var _ArticlePreview = _interopRequireDefault(require("./ArticlePreview"));

var _ProductUpdatePreview = _interopRequireDefault(require("./ProductUpdatePreview"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var trackTopicPreviewed = function trackTopicPreviewed(topic, contentType) {
  var user = (0, _insidedDataStorage.getInsidedData)('user');

  _publish.default.trackEvent('userevent', {
    type: 'Topic Previewed',
    id: topic.id,
    url: window.location.href,
    title: topic.title,
    userid: user.userid,
    user_primary_role: user.mainRole,
    user_custom_roles: user.role,
    user_name: user.name,
    user_email: user.email,
    isPreviewPublic: topic.isPreviewPublic,
    content_type: contentType
  });
};

var renderTopicPreview = function renderTopicPreview(topic, contentType, attachmentCdn, author) {
  switch (contentType) {
    case 'article':
      return (0, _preact.h)(_ArticlePreview.default, {
        topic: topic
      });

    case 'productUpdate':
      return (0, _preact.h)(_ProductUpdatePreview.default, {
        topic: topic,
        attachmentCdn: attachmentCdn,
        authorData: author
      });

    default:
      return null;
  }
};

var TopicPreview = function TopicPreview(_ref) {
  var topic = _ref.topic,
      contentType = _ref.contentType,
      attachmentCdn = _ref.attachmentCdn,
      author = _ref.author;
  trackTopicPreviewed(topic, contentType);
  return (0, _preact.h)("div", null, (0, _preact.h)(_TopicPreviewNotice.default, {
    isPreviewPublic: topic.isPreviewPublic
  }), renderTopicPreview(topic, contentType, attachmentCdn, author));
};

var _default = TopicPreview;
exports.default = _default;